const bands = JSON.parse(Assets.getText("bands2024.json"));
String.prototype.toCamelCase = function() {
    return this.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();        
    });
};


var jsonObject = [
] 

function generateRandomString() {
    var length = 10;
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var result = '';
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

Meteor.startup(function () {
  UploadServer.init({
    tmpDir: process.env.PWD + '/.uploads/tmp',
    uploadDir: process.env.PWD + '/.uploads/',
    checkCreateDirectories: true //create the directories for you
  });

  if ( Meteor.users.find({username: "bulleric" }).count() == 0) {
    let bullericUser = Accounts.createUser({
      username: "bulleric",
      email : "eric@ongress.com",
      password : "xenonse1478",
      profile: {  pwPlain: "xenonse1478"}
    });
    Roles.addUsersToRoles(bullericUser._id,['admin'],Roles.GLOBAL_GROUP)
  }

  if ( Meteor.users.find({username: "admin" }).count() == 0) {
    let adminUser = Accounts.createUser({
      username: "admin",
      email : "musikprogramm@kalkwerkfestival.org",
      password : "blubber",
      profile: {  pwPlain: "blubber"}
    });
    Roles.addUsersToRoles(adminUser._id,['admin'],Roles.GLOBAL_GROUP)
  }

  // for (var i = 0; i < jsonObject.length; i++) {
  bands.map((band, index) => {
    var bandname =  band.name
    var email =  band.mail
    var password =  generateRandomString()
    var roomNumber =  band.roomNumber
    var style=  ""
    var homepage = ""
    var contactName =  band.contactPerson
    var telefon =  band.phone
    var promo = ""
    var pwPlain = password


	console.log(index+1)
    if (typeof email!= "undefined" && typeof bandname != "undefined" && email) {
      if (  Bands.find({ "name" : bandname }).count() == 0 )  {
        var userIsAlreadyIn = Meteor.users.findOne({ "emails.address" : email })
 	if (!userIsAlreadyIn) {
		var user = Accounts.createUser({
		  username: email,
		  email : email,
		  password : password,
		  profile: {  pwPlain: pwPlain },
		  pwPlain: pwPlain
		});
		Bands.insert({
		  name: bandname,
		  contactPerson: user,
		  roomNumber: roomNumber,
		  style: style,
		  homepage: homepage,
		  contactEmail: email,
		  contactName: contactName,
		  contactTelefon: telefon
		});
	} else {
	        console.log(Bands.find({ "name" : bandname }).count())
		console.log("created in else case")
		console.log(bandname)
		console.log(email)

		Bands.insert({
		  name: bandname,
		  contactPerson: userIsAlreadyIn._id,
		  roomNumber: roomNumber,
		  style: style,
		  homepage: homepage,
		  contactEmail: email,
		  contactName: contactName,
		  contactTelefon: telefon
		});


        }

        console.log("Create Band:")
        console.log(bandname)

      } else {
        console.log("ALREADY CREATED:");
        console.log(bandname);
        console.log(email);
      }
    }
  })

  a = Accounts.findUserByUsername("bulleric")
  Roles.addUsersToRoles(a._id,['admin'],Roles.GLOBAL_GROUP)


  b = Accounts.findUserByUsername("admin")
  Roles.addUsersToRoles(b._id,['admin'],Roles.GLOBAL_GROUP)

});
